<template>
  <div class="c-list-box">
    <ul class="c-list-nav">
      <li class="c-list-title">未算税员工</li>
      <el-button
        type="warning"
        :icon="Upload"
        link
        @click="onDeclares()"
        v-if="$judge_auth('567')"
      >
        批量离职报送
      </el-button>
      <el-button
        type="primary"
        :icon="Upload"
        link
        @click="onZeroDeclares()"
        v-if="$judge_auth('566')"
      >
        批量零申报
      </el-button>
      <el-button
        type="primary"
        :icon="Upload"
        link
        @click="onExport"
        size="large"
        v-if="$judge_auth('692')"
        >导出
      </el-button>
      <el-button
        type="primary"
        :icon="Refresh"
        link
        @click="state.showAgent = true"
        size="large"
        v-if="$judge_auth('677')"
        >手动更新
      </el-button>
    </ul>
    <ul class="c-list-search">
      <c_statusradiogroup
        v-model="state.params.deal_status"
        arrName="uncalctaxemployee_deal_status"
        @change="onLoad"
      ></c_statusradiogroup>
      <el-date-picker
        v-model="state.params.calc_tax_month"
        type="month"
        placeholder="所属税期"
        format="YYYY年M月"
        value-format="YYYYMM"
      />
      <el-input
        v-model="state.params.keywords"
        style="width: 300px"
        placeholder="姓名、证件号"
        clearable
        @clear="
          delete state.params.keywords;
          onLoad();
        "
        @paste.enter="$onKeywordsPaste($event, state.params)"
      ></el-input>
      <div
        class="c-withholdingagent-search-box"
        @click="state.showWithholdingAgent = true"
      >
        <li style="flex: 1; display: flex; column-gap: 5px">
          <template v-if="state.withholding_agent_arr?.length > 0">
            <div
              class="c-withholdingagent-search-tag"
              style="
                max-width: 200px;
                overflow: hidden;
                text-overflow: ellipsis;
              "
            >
              {{ state.withholding_agent_arr[0]?.name }}
            </div>
            <el-popover
              v-if="state.withholding_agent_arr?.length > 1"
              placement="right"
              width="auto"
              popper-style="max-height: 90vh;overflow-y: auto;"
            >
              <template #reference>
                <div class="c-withholdingagent-search-tag" @click.stop="">
                  {{ "+ " + (state.withholding_agent_arr?.length - 1) }}
                </div>
              </template>
              <template #default>
                <div
                  style="
                    display: flex;
                    flex-direction: column;
                    row-gap: 5px;
                    width: fit-content;
                  "
                >
                  <ul
                    v-for="(item, index) in state.withholding_agent_arr"
                    :key="item"
                    style="
                      white-space: nowrap;
                      background-color: #f0f2f5;
                      color: var(--el-color-info);
                      border-radius: 4px;
                      font-size: 12px;
                      padding: 0 9px;
                      height: 24px;
                      line-height: 24px;
                      display: flex;
                      align-items: center;
                      column-gap: 10px;
                    "
                  >
                    <li>{{ item.name }}</li>
                    <el-icon
                      @click.stop="state.withholding_agent_arr.splice(index, 1)"
                      color="#a2a2a2"
                      style="cursor: pointer"
                      ><CircleClose
                    /></el-icon>
                  </ul>
                </div>
              </template>
            </el-popover>
          </template>
          <text v-else style="color: #a2a2a2">点击选择扣缴义务人</text>
        </li>
        <el-icon
          v-if="state.withholding_agent_arr?.length > 0"
          @click.stop="delete state.withholding_agent_arr"
          color="#a2a2a2"
          ><CircleClose
        /></el-icon>
      </div>
      <el-select
        v-model="state.params.customer_id"
        placeholder="所属客户"
        style="width: 300px"
      >
        <el-option
          v-for="item in state.customerData"
          :key="item.id"
          :label="item.alias + '(' + item.name + ')'"
          :value="item.id"
        />
        <template #footer>
          <el-button size="small" @click="onLoadCustomer()"> 刷新 </el-button>
        </template>
      </el-select>
      <el-tree-select
        v-model="state.params.belonger_id"
        :props="{
          value: 'id',
          label: 'name',
          class: 'belonger-tree-class',
        }"
        placeholder="负责人"
        :data="state.admin_data"
        style="width: 200px"
        default-expand-all
        filterable
        clearable
      >
        <template #default="{ data }">
          <el-icon :size="16" v-if="data.type == 0"><UserFilled /></el-icon>
          <el-icon :size="16" v-else><User /></el-icon>
          <span style="margin-left: 3px">{{ data.name }}</span>
        </template>
      </el-tree-select>
      <el-radio-group v-model="state.params.deal_type" @change="onLoad">
        <el-radio-button>全部</el-radio-button>
        <el-radio-button :value="0">零申报</el-radio-button>
        <el-radio-button :value="1">离职</el-radio-button>
      </el-radio-group>
      <el-config-provider
        :value-on-clear="null"
        :empty-values="[undefined, null]"
      >
        <el-select
          v-model="state.params.is_have_calc_tax"
          placeholder="是否包含其他算税类型"
          style="width: 200px"
        >
          <el-option
            label="包含其他算税类型"
            :value="1"
            style="color: #1e90ff"
          />
          <el-option label="不含其他算税类型" :value="0" />
        </el-select>
      </el-config-provider>
      <el-dropdown split-button @click="onLoad" type="primary">
        查询
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
              重置
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </ul>
    <ul class="c-list-table">
      <el-table
        ref="tableDom"
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
        @row-click="onRowClick"
      >
        <el-table-column type="selection" width="55" fixed />
        <el-table-column
          fixed
          label="序号"
          width="50"
          type="index"
          :index="
            (index) => (state.params.page - 1) * state.params.limit + index + 1
          "
          align="center"
        />
        <el-table-column
          label="姓名"
          prop="name"
          sortable="name"
          :width="100"
          :formatter="$tab_TextFormat"
          fixed
        />
        <el-table-column prop="idcard" label="证件号" width="180">
          <template #default="{ row }">
            <text
              style="color: #1e90ff"
              class="text-hover-decoration"
              title="证件号"
              @click.stop="$onCopy(row.idcard)"
            >
              {{ row.idcard }}
            </text>
          </template>
        </el-table-column>
        <!-- <el-table-column
          label="所属税期"
          prop="real_calc_tax_month"
          sortable="real_calc_tax_month"
          :min-width="120"
          :formatter="$tab_TextFormat"
        /> -->
        <el-table-column
          label="工资表"
          prop="payroll_order_id"
          :min-width="200"
          :formatter="$tab_TextFormat"
          v-if="state.params.is_zero_declare == 1"
        >
          <template #default="{ row }">
            <text
              style="color: #1e90ff"
              class="text-hover-decoration"
              title="工资表"
              @click.stop="$onCopy(row.payroll_order_id)"
            >
              {{ row.payroll_order_id }}
            </text>
          </template>
        </el-table-column>
        <el-table-column
          label="算税单"
          :min-width="200"
          :formatter="$tab_TextFormat"
          v-if="state.params.is_zero_declare == 1"
        >
          <template #default="{ row }">
            <text
              style="color: #1e90ff"
              class="text-hover-decoration"
              title="算税单"
              @click.stop="$onCopy(row.calc_tax_order_id)"
            >
              {{ row.calc_tax_order_id }}
            </text>
          </template>
        </el-table-column>
        <el-table-column label="证件类型" prop="idtype" :min-width="120" />
        <el-table-column
          label="扣缴义务人"
          prop="status"
          sortable="status"
          :min-width="200"
        >
          <template #default="{ row }">
            <div
              v-if="row.withholding_agent_id"
              :data-type="row.withholding_agent_type == 1 ? '供' : '扣'"
              :style="{
                '--dynamic-color':
                  row.withholding_agent_type == 1 ? '#1e90ff' : '#ffa500',
              }"
              class="withholding-badge"
            >
              {{ row.withholding_agent_name }}
            </div>
            <text v-else>-</text>
          </template>
        </el-table-column>
        <el-table-column
          label="统一社会信用代码"
          prop="unified_social_credit_identifier"
          :min-width="160"
        />
        <el-table-column
          label="所属客户"
          prop="customer_name"
          sortable="customer_name"
          :min-width="200"
        />
        <el-table-column
          label="负责人"
          prop="belonger_name"
          :width="80"
          align="center"
        />
        <el-table-column
          label="其他算税类型"
          prop="belonger_name"
          :width="120"
          align="center"
        >
          <template #default="{ row }">
            <text v-if="row.is_have_calc_tax" style="color: #1e90ff">有</text>
            <text v-else>无</text>
          </template>
        </el-table-column>
        <el-table-column
          label="属性"
          prop="property_name"
          sortable="property_name"
          :min-width="120"
        />
        <el-table-column
          label="入职日期"
          prop="entry_time"
          sortable="entry_time"
          :min-width="120"
        />
        <el-table-column
          label="离职日期"
          prop="resignation_time"
          sortable="resignation_time"
          :min-width="120"
        />
        <el-table-column
          label="处理类型"
          prop="deal_type_name"
          :min-width="120"
          align="center"
        >
          <template #default="{ row }">
            <text v-if="row.deal_status == 0">-</text>
            <text v-else>{{ row.deal_type_name }}</text>
          </template>
        </el-table-column>
        <el-table-column
          label="人员状态"
          prop="verify_status_name"
          :min-width="120"
        />
        <el-table-column
          label="报送状态"
          prop="declare_status_name"
          :min-width="120"
        />
        <el-table-column
          label="报送时间"
          prop="declare_time"
          sortable="declare_time"
          :min-width="180"
        />
        <el-table-column
          label="处理状态"
          sortable="deal_status"
          fixed="right"
          align="center"
          :width="120"
        >
          <template #default="{ row }">
            <c_status
              arrName="uncalctaxemployee_deal_status"
              :value="row.deal_status"
              style="margin: auto"
            />
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="220"
          align="center"
          fixed="right"
          v-if="$judge_auth(['566', '567', '789'])"
        >
          <template #default="{ row }">
            <el-button
              type="warning"
              link
              icon="Upload"
              @click="
                state.selectItem = row;
                state.showSetDate = true;
              "
              v-if="$judge_auth('567')"
              :disabled="![0, 3].includes(row.deal_status)"
              >离职报送
            </el-button>
            <el-button
              type="primary"
              link
              icon="Upload"
              @click="
                state.selectItems = [row];
                state.showZeroDeclare = true;
              "
              v-if="$judge_auth('566')"
              :disabled="![0, 3].includes(row.deal_status)"
              >零申报
            </el-button>
            <el-button
              type="danger"
              link
              icon="Delete"
              @click="onDelete(row.id)"
              v-if="$judge_auth('789')"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </ul>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showDeclare"
        title="批量离职报送"
        @close="state.showDeclare = false"
      >
        <c_UnCalcTaxEmployeeDeclare
          @close="
            state.showDeclare = false;
            onLoad();
          "
          :data="state.selectItems"
        ></c_UnCalcTaxEmployeeDeclare>
      </c_popup>
    </transition>
    <el-dialog
      v-model="state.showSetDate"
      title="离职报送"
      width="300"
      align-center
      :show-close="false"
    >
      <div>
        <ul>
          <text>员工姓名：</text
          >{{
            state.selectItem?.name
          }}
        </ul>
        <ul style="display: flex; align-items: center; margin-top: 20px">
          <text>离职日期：</text>
          <el-date-picker
            v-model="state.selectItem.resignation_time"
            type="day"
            placeholder="离职日期"
            format="YYYY年M月D日"
            value-format="YYYY-MM-DD"
            style="flex: 1"
          />
        </ul>
        <div style="display: flex; margin-top: 30px">
          <el-button
            @click="state.showSetDate = false"
            size="large"
            style="width: 100px"
            plain
          >
            取消
          </el-button>
          <el-button
            type="primary"
            @click="onDeclare"
            size="large"
            style="flex: 1"
          >
            确定报送
          </el-button>
        </div>
      </div>
    </el-dialog>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showZeroDeclare"
        title="零申报创建工资表"
        @close="state.showZeroDeclare = false"
      >
        <c_UnCalcTaxEmployeeAddPayroll
          v-if="state.showZeroDeclare"
          @close="
            state.showZeroDeclare = false;
            onLoad();
          "
          :items="state.selectItems"
        ></c_UnCalcTaxEmployeeAddPayroll>
      </c_popup>
    </transition>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showWithholdingAgent"
        title="选择扣缴义务人"
        @close="state.showWithholdingAgent = false"
      >
        <c_WithholdingAgentSelect
          @close="
            (arr) => {
              state.withholding_agent_arr = arr;
              state.showWithholdingAgent = false;
            }
          "
          :selectItems="state.withholding_agent_arr"
        ></c_WithholdingAgentSelect>
      </c_popup>
    </transition>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="
          state.showWithholdingAgent &&
          state.params.withholding_agent_type === 1
        "
        title="选择供应商"
        @close="state.showWithholdingAgent = false"
      >
        <c_SupplierSelect
          @close="
            (arr) => {
              state.withholding_agent_arr = arr;
              state.showWithholdingAgent = false;
            }
          "
          :selectItems="state.withholding_agent_arr"
        ></c_SupplierSelect>
      </c_popup>
    </transition>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showAgent"
        title="手动更新未算税员工"
        @close="state.showAgent = false"
      >
        <c_Agent
          v-if="state.showAgent"
          @close="state.showAgent = false"
          @confirm="onSelectConfirm"
          :skssnd="state.params.calc_tax_month"
        ></c_Agent>
      </c_popup>
    </transition>
    <el-dialog
      v-model="state.showUpdate"
      title="手动更新"
      width="300px"
      align-center
    >
      <ul>
        请选择税期
      </ul>
      <el-date-picker
        v-model="state.calc_tax_month"
        type="month"
        placeholder="所属税期"
        format="YYYY年M月"
        value-format="YYYYMM"
        style="width: 100%; margin-top: 10px"
      />
      <ul style="text-align: right; margin-top: 40px">
        <el-button
          type="primary"
          @click="onUpdate"
          size="large"
          style="width: 100%"
        >
          提交
        </el-button>
      </ul>
    </el-dialog>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import { admin_cascader } from "@/utils/qFormat";
import { data_customer_select } from "@/http/data";
import {
  uncalctaxemployee_list,
  uncalctaxemployee_resignationdeclares,
  uncalctaxemployee_export,
  uncalctaxemployee_update,
  uncalctaxemployee_delete,
} from "@/http/uncalctaxemployee";
import { taxtype_select } from "@/http/dictionary";
import { dayjs, ElMessage, ElMessageBox } from "element-plus";
import { confirm_func } from "@/utils/qFormat";

import c_Agent from "./SelectWithholdingAgent.vue";

class InitFormData {
  params = {
    limit: 20,
    page: 1,
  };
}
export default {
  components: {
    c_Agent,
  },
  setup() {
    const tableDom = ref(null);
    const state = reactive({
      ...new InitFormData(),
      selectItem: {},
      model: {},
    });
    onMounted(() => {
      state.params.calc_tax_month = dayjs()
        .subtract(1, "month")
        .format("YYYYMM");

      onLoadTaxType();
      onLoadAdmin();
      onLoadCustomer();
      onLoad();
    });

    const onLoadTaxType = () => {
      taxtype_select().then((res) => {
        if (res.status == 200) state.taxTypeData = res.data.data;
      });
    };

    //加载负责人
    const onLoadAdmin = () => {
      admin_cascader().then((res) => {
        state.admin_data = res;
      });
    };

    const onLoad = () => {
      delete state.tableData;

      if (state.withholding_agent_arr?.length > 0)
        state.params.withholding_agent_id = state.withholding_agent_arr
          ?.map((m) => m.id)
          .join(",");
      else delete state.params.withholding_agent_id;

      uncalctaxemployee_list(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data.data;

          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    //获取客户
    const onLoadCustomer = () => {
      data_customer_select().then((res) => {
        if (res.status == 200) state.customerData = res.data.data?.list;
      });
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      } else {
        const params = new InitFormData().params;
        state.params.sort_field = params.Order;
        state.params.sort_value = "asc";
      }
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      delete state.withholding_agent_uid;
      Object.assign(state, new InitFormData());
      onLoad();
    };

    //表格行点击事件
    const onRowClick = (row) => {
      tableDom.value.toggleRowSelection(row);
    };

    const onDeclare = () => {
      if (state.selectItem?.resignation_time) {
        uncalctaxemployee_resignationdeclares(
          JSON.stringify([
            {
              id: state.selectItem?.id,
              resignation_time: state.selectItem?.resignation_time,
            },
          ]),
        ).then((res) => {
          if (res.status == 200) {
            ElMessage.success(res.data.msg);
            state.showSetDate = false;
            onLoad();
          }
        });
      } else {
        ElMessage.warning("请选择离职日期！");
      }
    };

    const onDeclares = () => {
      const rows = tableDom.value.getSelectionRows();
      if (rows.length <= 0) {
        ElMessage({
          type: "warning",
          message: "请选择要报送的员工",
          grouping: true,
        });
        return false;
      }

      state.selectItems = rows;
      state.showDeclare = true;
    };

    const onZeroDeclares = () => {
      const rows = tableDom.value.getSelectionRows();
      if (rows.length <= 0) {
        ElMessage({
          type: "warning",
          message: "请选择要报送的员工",
          grouping: true,
        });
        return false;
      }

      state.selectItems = rows;
      state.showZeroDeclare = true;
    };

    const onExport = () => {
      let params = JSON.parse(JSON.stringify(state.params));
      params.limit = 0;
      uncalctaxemployee_export(params)
        .then((res) => {
          let fileName = decodeURI(
            res.headers["content-disposition"].split("=")[1],
          );

          //通过后台返回 的word文件流设置文件名并下载
          var blob = new Blob([res.data], {
            type: res.data.type,
          });
          var downloadElement = document.createElement("a");
          var href = window.URL.createObjectURL(blob); //创建下载的链接
          downloadElement.href = href;
          downloadElement.download = fileName; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
        })
        .catch((err) => {
          const fileReader = new FileReader();
          fileReader.readAsText(
            new Blob([err.data], { type: "application/octet-stream" }),
            "utf-8",
          );
          fileReader.onload = () => {
            const msg = JSON.parse(fileReader.result);
            ElMessage.error(msg?.msg);
          };
        });
    };

    const onUpdate = () => {
      if (!state.calc_tax_month) {
        ElMessage({
          type: "warning",
          grouping: true,
          message: "请选择税期！",
        });
        return false;
      }

      ElMessageBox.confirm(`您确定更新吗？`, "提示", {
        dangerouslyUseHTMLString: true,
        confirmButtonText: "立即更新",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        uncalctaxemployee_update({
          calc_tax_month: state.calc_tax_month,
        }).then((res) => {
          if (res.stauts == 200) {
            ElMessage.success(res.data.msg);
            onLoad();
          }
        });
      });
    };

    //删除
    const onDelete = (id) => {
      confirm_func(uncalctaxemployee_delete, id, onLoad);
    };

    return {
      state,
      tableDom,
      onLoad,
      onSortChange,
      onReset,
      onLoadCustomer,
      onRowClick,
      onLoadAdmin,
      onDeclare,
      onDeclares,
      onZeroDeclares,
      onExport,
      onUpdate,
      onDelete,
    };
  },
};
</script>
<style></style>
